module.exports = __webpack_public_path__ + "static/media/张衡一号.8c4f7dd1.png";